/**
 * mk-custom.js
 * Central home for custom interactive behavior on top of the Dawn-Manulla
 * theme. Loaded in layout/theme.liquid. Add new behavior inside the MK
 * namespace below rather than creating separate script files, so it's easy
 * to find everything custom in one place.
 *
 * Nothing lives here yet: the sections ported from the design reference so
 * far (fonts, tokens in mk-custom.css) are pure CSS, and value props /
 * testimonials / FAQ already exist natively elsewhere in the theme with
 * their own working JS (or, for the FAQ accordion, no JS at all - it uses
 * native <details>/<summary>). See task.md for the full breakdown.
 */
window.MK = window.MK || {};
